import { ElementRef, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PDFService {
  private pdfGrantContentSubject = new BehaviorSubject<ElementRef | null>(null);
  pdfGrantContent$ = this.pdfGrantContentSubject.asObservable();

  private pdfChecklistContentSubject = new BehaviorSubject<ElementRef | null>(null);
  pdfChecklistContent$ = this.pdfChecklistContentSubject.asObservable();

  private pdfGrantContentReadyPromise: Promise<ElementRef> | null = null;
  private resolvePdfGrantContentReady: ((value: ElementRef) => void) | null = null;

  private pdfChecklistContentReadyPromise: Promise<ElementRef> | null = null;
  private resolvePdfChecklistContentReady: ((value: ElementRef) => void) | null = null;

  constructor() {
    this.pdfGrantContentReadyPromise = new Promise((resolve) => {
      this.resolvePdfGrantContentReady = resolve;
    });
    this.pdfChecklistContentReadyPromise = new Promise((resolve) => {
      this.resolvePdfChecklistContentReady = resolve;
    });
  }

  setGrantPdfContent(pdfContent: ElementRef | null) {
    this.pdfGrantContentSubject.next(pdfContent);
    if (this.resolvePdfGrantContentReady && pdfContent) {
      this.resolvePdfGrantContentReady(pdfContent);
      // Reset the promise after resolving
      this.pdfGrantContentReadyPromise = null;
      this.resolvePdfGrantContentReady = null;
    }
  }

  setChecklistPdfContent(pdfContent: ElementRef | null) {
    this.pdfChecklistContentSubject.next(pdfContent);
    if (this.resolvePdfChecklistContentReady && pdfContent) {
      this.resolvePdfChecklistContentReady(pdfContent);
      // Reset the promise after resolving
      this.pdfChecklistContentReadyPromise = null;
      this.resolvePdfChecklistContentReady = null;
    }
  }

  waitForPdfGrantContent(): Promise<ElementRef> {
    // If content is already available, return it immediately
    const currentContent = this.pdfGrantContentSubject.getValue();
    if (currentContent) {
      return Promise.resolve(currentContent);
    }

    // Create a new promise if one doesn't exist
    if (!this.pdfGrantContentReadyPromise) {
      this.pdfGrantContentReadyPromise = new Promise((resolve) => {
        this.resolvePdfGrantContentReady = resolve;
      });
    }
    return this.pdfGrantContentReadyPromise;
  }
  
  waitForPdfChecklistContent(): Promise<ElementRef> {
    // If content is already available, return it immediately
    const currentContent = this.pdfGrantContentSubject.getValue();
    if (currentContent) {
      return Promise.resolve(currentContent);
    }

    // Create a new promise if one doesn't exist
    if (!this.pdfChecklistContentReadyPromise) {
      this.pdfChecklistContentReadyPromise = new Promise((resolve) => {
        this.resolvePdfChecklistContentReady = resolve;
      });
    }
    return this.pdfChecklistContentReadyPromise;
  }
}
